import { sortBy, uniq } from 'lodash-es';
import { derived, get, type Readable, writable } from 'svelte/store';
import { slugify, type UrlCountry } from '$lib/UrlHelper.js';
import type { IntlUtils } from '$lib/intl.js';
import singleton from '$lib/utils/factory';

export class CountryHelper {
    mainCountries: readonly string[];
    modalCountries: readonly string[];
    alternateCountries: readonly string[];
    footerCountries: readonly string[];

    constructor(
        private readonly intl: IntlUtils,
        public readonly initialCurrentCountry: string | null,
    ) {
        this.mainCountries = ['ci', 'bf', 'cm', 'tg', 'sn', 'ga', 'gn', 'bj', 'cd'];
        this.modalCountries = [
            'ci',
            'bf',
            'cm',
            'tg',
            'sn',
            'ga',
            'gn',
            'bj',
            'cd',
            'ml',
            'gh',
            'ng',
            'lr',
            'cg',
            'bw',
            'za',
            'so',
            'ke',
            'et',
            'tz',
            'cf',
            'ne',
            'ma',
            'dz',
            'tn',
            'eg',
            'mw',
            'ao',
            'na',
            'mz',
            'mg',
            'mu',
            'ug',
            'dj',
        ];
        this.alternateCountries = [...this.modalCountries];
        this.footerCountries = [
            'ci',
            'bf',
            'cm',
            'tg',
            'sn',
            'ga',
            'gn',
            'bj',
            'cd',
            'ml',
            'gh',
            'ng',
            'lr',
            'cg',
            'bw',
            'za',
            'so',
            'ke',
            'et',
            'tz',
            'cf',
            'ne',
            'ma',
            'dz',
            'tn',
            'eg',
            'mw',
            'ao',
            'na',
            'mz',
            'mg',
            'mu',
            'ug',
            'dj',
        ];
    }

    sortCountries(countries: readonly string[]): string[] {
        return sortBy(uniq(countries), (c) => {
            return slugify(this.intl.countryLabel(c));
        });
    }

    currentCountry = singleton(() => {
        return writable(this.initialCurrentCountry);
    });

    resolveCountry(this: this, country: UrlCountry): Readable<string | null> {
        function calc(currentCountry: string | null): string | null {
            if (typeof country === 'string') {
                return country;
            } else if (country.type === 'UseCurrent') {
                return currentCountry;
            } else if (country.type === 'null') {
                return null;
            } else {
                return currentCountry;
            }
        }

        return derived(
            this.currentCountry(),
            ($currentCountry, set) => {
                set(calc($currentCountry));
            },
            calc(get(this.currentCountry())),
        );
    }
}
